import React, { useEffect, useState } from 'react';

const COLORS = ['#00FF41', '#33FF66', '#FFD700', '#FF6B6B', '#4ECDC4', '#FFFFFF', '#FF00FF', '#00BFFF'];

const ConfettiPiece = ({ delay, left, color, duration, rotation }) => (
  <div
    className="absolute top-0 pointer-events-none"
    style={{
      left: `${left}%`,
      width: `${6 + Math.random() * 8}px`,
      height: `${4 + Math.random() * 6}px`,
      background: color,
      borderRadius: Math.random() > 0.5 ? '50%' : '2px',
      opacity: 0,
      animation: `confettiFall ${duration}s ease-out ${delay}s forwards`,
      transform: `rotate(${rotation}deg)`,
      boxShadow: `0 0 6px ${color}66`,
    }}
  />
);

const Confetti = ({ active = true, duration = 4 }) => {
  const [pieces, setPieces] = useState([]);

  useEffect(() => {
    if (!active) return;
    const generated = [];
    // 3 waves of confetti
    for (let wave = 0; wave < 3; wave++) {
      const count = 40 + Math.floor(Math.random() * 20);
      for (let i = 0; i < count; i++) {
        generated.push({
          id: `${wave}_${i}`,
          delay: wave * 0.8 + Math.random() * 0.5,
          left: Math.random() * 100,
          color: COLORS[Math.floor(Math.random() * COLORS.length)],
          duration: 2 + Math.random() * 2,
          rotation: Math.random() * 360,
        });
      }
    }
    setPieces(generated);

    const timer = setTimeout(() => setPieces([]), (duration + 1) * 1000);
    return () => clearTimeout(timer);
  }, [active, duration]);

  if (pieces.length === 0) return null;

  return (
    <div data-testid="confetti-effect" className="fixed inset-0 z-[99999] pointer-events-none overflow-hidden">
      {pieces.map(p => (
        <ConfettiPiece key={p.id} {...p} />
      ))}
      <style>{`
        @keyframes confettiFall {
          0% {
            opacity: 1;
            transform: translateY(-20px) rotate(0deg) scale(1);
          }
          20% {
            opacity: 1;
          }
          100% {
            opacity: 0;
            transform: translateY(100vh) rotate(${720 + Math.random() * 360}deg) scale(0.3);
          }
        }
      `}</style>
    </div>
  );
};

export default Confetti;
